import { useState } from 'react';
import { getDpLang, setDpLang, getDpAge, setDpAge } from '../dpLang';
import './AgeGate.css';

const copy = {
  en: {
    warning:  'Thou art entering realms of erotic and BDSM nature.',
    question: 'Should such matters offend thee, or shouldst thou not yet have reached thy eighteenth year — DEPART!!!',
    enter:    'I am of Age — Enter',
    leave:    'Depart',
    sub:      'By thy passage herein, thou dost renounce all claims to recompense for any affliction wrought upon thee by the contents of these pages.',
  },
  cs: {
    warning:  'Vstupuješ do říší erotické a BDSM povahy.',
    question: 'Pokud tě tyto záležitosti pohoršují, anebo nedosáhl jsi ještě let osmnácti — ODEJDI!!!',
    enter:    'Dosáhl jsem věku — Vstoupit',
    leave:    'Odejít',
    sub:      'Svým vstupem se zříkáš veškerých nároků na náhradu za jakoukoli újmu, jež by ti z obsahu těchto stránek vzešla.',
  },
};

export default function AgeGate() {
  const [confirmed, setConfirmed] = useState(getDpAge);
  const [lang, setLang] = useState(getDpLang);

  if (confirmed) return null;

  const t = copy[lang];

  function pickLang(next) {
    setLang(next);
    setDpLang(next);
  }

  function enter() {
    setDpAge();
    setConfirmed(true);
  }

  function leave() {
    window.location.replace('https://www.google.com');
  }

  return (
    <div className="age-gate" role="dialog" aria-modal="true">
      <div className="age-gate__box">

        <div className="age-gate__lang">
          <button
            className={`age-gate__lang-btn${lang === 'en' ? ' active' : ''}`}
            onClick={() => pickLang('en')}
          >EN</button>
          <span className="age-gate__lang-sep">|</span>
          <button
            className={`age-gate__lang-btn${lang === 'cs' ? ' active' : ''}`}
            onClick={() => pickLang('cs')}
          >CS</button>
        </div>

        <p className="age-gate__warning">{t.warning}</p>
        <p className="age-gate__question">{t.question}</p>
        <p className="age-gate__sub">{t.sub}</p>

        <div className="age-gate__actions">
          <button className="age-gate__btn age-gate__btn--enter" onClick={enter}>
            {t.enter}
          </button>
          <button className="age-gate__btn age-gate__btn--leave" onClick={leave}>
            {t.leave}
          </button>
        </div>

      </div>
    </div>
  );
}
